import "./Transform.css";
import transform from "../Images/transform.png";
const Transform = () => {
  return (
    <div id="transform" className="divWrapper">
      <div className="arvrcontainer transformContainer">
        <div className="contentSide">
          <h2 className="heading">
            Want to Transform Ideas into Immersive Reality?
          </h2>
          <p>
            We craft next-generation augmented and <span className="strong">virtual reality development
            services </span> that expand the limits of what is possible. From fully
            immersive VR simulations to interactive AR experiences, our
            experiences are designed to educate, engage, and uplift.
          </p>
          <p>
            If you need to develop interactive AR catalogs, <span className="strong">virtual reality
            application development services</span>, or engaging product
            demonstrations, we combine imagination with cutting-edge technology
            to provide high-impact solutions. Our <span className="strong">AR/VR Development</span> helps brands
            in the education sector, healthcare industry, retail sector, and
            manufacturing businesses rethink how they interact with customers.
          </p>
        </div>
        <div className="contentImage">
          <img src={transform} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Transform;
